// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__3HwoG","title":"styles_title__3YFcP","data":"styles_data__2G2Bd"};